import { convertPeriodLabelToFrequency } from "library/convert-period-label-to-frequency.mjs"
import { periodIntervalHoursFromTask } from "library/period-interval-hours-from-task.mjs"
import { getFrequencyLabel } from "library/get-frequency-label.mjs"
import { convertIntervalInHoursToFrequency } from "library/convert-interval-in-hours-to-frequency.mjs"

export function normalisePeriod(periodLabel) {
    const frequency = convertPeriodLabelToFrequency(periodLabel)
    const hours = periodIntervalHoursFromTask({ frequency })
    return getFrequencyLabel(convertIntervalInHoursToFrequency(hours))
}
